import {Map} from "immutable"

const connection = (state = Map({ 'input': false, 'output' : false}), action) => {

    switch (action.type){
        case 'SET_INPUT':
            return state.set('input', action.input);
        case 'SET_OUTPUT':
            return state.set('output', action.output);
        case 'IS_DOWNLOADING':
            console.log("action", action)
            return state.set('downloading',action.downloading)
        default:
            return state
    }
}

export default connection